import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '../providers/ToastProvider';
import { setCloudFileAsProfilePicture } from '../services/patientFiles';
import { apiErrorMessage } from '../utils/apiError';
import { invalidateProfilePictureQueries } from './profilePictureQueries';

const SUCCESS_MESSAGE = 'Profile picture updated';
const FALLBACK_ERROR = 'Could not set the profile picture. Please try again.';

export interface SetProfilePictureVariables {
    patientId: string;
    patientFileId: string;
}

export function useSetProfilePicture() {
    const queryClient = useQueryClient();
    const { showToast } = useToast();

    return useMutation({
        mutationFn: ({ patientId, patientFileId }: SetProfilePictureVariables) =>
            setCloudFileAsProfilePicture(patientId, patientFileId),
        onSuccess: (_data, { patientId }) => {
            showToast(SUCCESS_MESSAGE, 'success');
            void invalidateProfilePictureQueries(queryClient, patientId);
        },
        onError: (error) => {
            showToast(apiErrorMessage(error, FALLBACK_ERROR), 'error');
        }
    });
}
